import * as _ from 'lodash';
import { useState } from 'react';
import { Glyphicon, Row } from 'react-bootstrap';
import { ToDoColumnWrapper } from '../styles';
import { ActionItem } from '../models';
import { IActionCenterCompliance } from '@nkr/models/index';
import { MainType } from './models/main-type';
import { OrganType, PackagingRemittance, StrongBoxComplianceType } from '@nkr/enums/index';
import ActionCenterItem from './action-center-item';
import ListType from '../list-type';
import PackagingRemittanceOverlay from './lists/packaging-remittance';

interface IProps {
    data: IActionCenterCompliance,
    centerId: number,
    showLoading: boolean,
    hideEmptyItems: boolean,
    organType: OrganType,
    onItemClick: (list: ListType[], mainType: MainType, subType: ActionItem) => void
}

const Compliance = (props: IProps) => {
    const [expanded, setExpanded] = useState(true);

    const handleItemClick = (list: ListType[], subType: ActionItem) => {
        if (subType == ActionItem.PendingPatientReferrals) {
            window.location.href = `/center/${props.centerId}/action-center/referrals`;
        } else {
            if (subType == ActionItem.Preselects) {
                handlePreselectOutstanding(list, subType);
            } else {
                props.onItemClick(list, MainType.Compliance, subType);
            }
        }
    };

    const handlePreselectOutstanding = (list: any[], subType: ActionItem) => {
        window.open(`center/${props.centerId}/recipients/donor-pre-select`);
    };

    const activeRecipientsDataCompliance = props.data != null ? props.data.activeRecipientsDataCompliance : [];
    const postTransplantRecipientsDataCompliance = props.data != null ? props.data.postTranplantRecipientsDataCompliance : [];
    const activeDonorsDataCompliance = props.data != null ? props.data.activeDonorsDataCompliance : [];
    const activeRdnDonorsDataCompliance = props.data != null ? props.data.activeRdnDonorsDataCompliance : [];
    const postTransplantDonorsDataCompliance = props.data != null ? props.data.postTranplantDonorsDataCompliance : [];
    const postTransplantRdnDonorsDataCompliance = props.data != null ? props.data.postTranplantRdnDonorsDataCompliance : [];
    const micrositeComplianceList = props.data != null ? props.data.micrositeComplianceList : [];
    const centerContactsDataCompliance = props.data != null ? props.data.centerContactPositionList : [];
    const strongBoxCompliance = props.data != null ? props.data.strongBoxComplianceList : [];
    const donorsWithRemoteRecipients = props.data != null ? props.data.donorsWithRemoteRecipient : [];
    const centerWaitListAnatomyCompliance = props.data != null ? props.data.complianceWaitListAnatomyList : [];
    const packagingRemittance = props.data != null && props.data.packagingRemittance.complianceValue != PackagingRemittance.Complete ? [props.data.packagingRemittance] : [];

    const show = props.organType == OrganType.Kidney;

    let items = [
        { name: 'Active Recipient Data Compliance', list: activeRecipientsDataCompliance, actionItem: ActionItem.ActiveRecipientDataCompliance, show },
        { name: 'Post Txp Recipient Data Compliance', list: postTransplantRecipientsDataCompliance, actionItem: ActionItem.PostTransplantRecipientDataCompliance, show },
        { name: 'Active Donor Data Compliance', list: activeDonorsDataCompliance, actionItem: ActionItem.ActiveDonorDataCompliance, show },
        { name: 'Active RDN Donor Data Compliance', list: activeRdnDonorsDataCompliance, actionItem: ActionItem.ActiveRdnDonorDataCompliance, show },
        { name: 'Post Txp Donor Data Compliance', list: postTransplantDonorsDataCompliance, actionItem: ActionItem.PostTransplantDonorDataCompliance, show },
        { name: 'Post Txp RDN Donor Data Compliance', list: postTransplantRdnDonorsDataCompliance, actionItem: ActionItem.PostTransplantRdnDonorDataCompliance, show },
        { name: 'Microsite Data Compliance', list: micrositeComplianceList, actionItem: ActionItem.MicrositeDataCompliance, show: true },
        { name: 'Center Contacts Data Compliance', list: centerContactsDataCompliance, actionItem: ActionItem.CenterContactPositions, show: true },
        { name: 'Donors Registered With Intended Recipients', list: donorsWithRemoteRecipients, actionItem: ActionItem.DonorsWithRemoteRecipient, show },
        { name: 'StrongBox Data Compliance', list: strongBoxCompliance, actionItem: ActionItem.StrongBoxDataCompliance, show },
        { name: 'Packaging Remittance', list: packagingRemittance, actionItem: ActionItem.PackagingRemittance, overlay: <PackagingRemittanceOverlay centerId={props.centerId} packagingRemittance={packagingRemittance.length > 0 ? packagingRemittance[0] : null} />, show },
        { name: 'Center Wait List Anatomy Compliance', list: centerWaitListAnatomyCompliance, actionItem: ActionItem.WaitListAnatomyCompliance, show }
    ];

    if (strongBoxCompliance.some(f => f.type == StrongBoxComplianceType.NotActive)) {
        items = items.filter(f => f.actionItem != ActionItem.StrongBoxDataCompliance);
    }

    const isEmpty = items.filter(x => x.list.length == 0).length == items.length;
    const itemCount = items.filter(x => x.list.length > 0).length;
    const itemList = _.sortBy(items, item => item.name);

    return (
        <div className='section-compliance'>
            <div className='title-container'>
                <div className='title' style={{ width: '27%' }} onClick={() => setExpanded(!expanded)}>
                    <h4>COMPLIANCE <span>({itemCount})</span></h4>
                    <span style={{ paddingLeft: 5 }}><Glyphicon glyph={expanded ? 'chevron-down' : 'chevron-up'} /></span>
                </div>
                <div style={{ borderBottom: '1px solid cadetblue', width: '73%' }}>&nbsp;</div>
            </div>
            {expanded ?
                <div className='content' style={{ flex: '1 1 auto', backgroundColor: props.showLoading ? '#eee' : null, opacity: props.showLoading ? 0.5 : 1 }}>
                    {props.showLoading && (
                        <div className="loader"><div className='message'>Loading compliance items, one moment please...</div></div>
                    )}

                    <div className='container-fluid'>
                        <Row>
                            {itemList.map((item, index) => {
                                 if (((!props.hideEmptyItems && item.list.length == 0) || item.list.length > 0) && item.show) {
                                    return (
                                        <ToDoColumnWrapper key={index} className='col-xs-12 col-lg-6'>
                                            <ActionCenterItem
                                                description={item.name}
                                                list={item.list}
                                                isList={true}
                                                color='white'
                                                highlight='#E35205'
                                                actionItem={item.actionItem}
                                                overlay={item.overlay}
                                                onItemClick={handleItemClick}
                                            />
                                        </ToDoColumnWrapper>
                                    )
                                }
                            })}
                        </Row>

                        {isEmpty && props.hideEmptyItems && (
                            <ToDoColumnWrapper className='col-xs-12 col-lg-12' style={{ fontSize: 16 }}>
                                At this time, there are no compliance items
                            </ToDoColumnWrapper>
                        )}
                    </div>
                </div>
                :
                <div className='content collapsed'></div>
            }
        </div>
    )
}

export default Compliance;